import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";

const LoanChart = () => {
  const [isBarChart, setIsBarChart] = useState({
    chart: {
      id: "apexchart-example",
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "March",
        "April",
        "May",
        "June",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
  });

  const [isBarChartSeries, setIsBarChartSeries] = useState([
    {
      name: "series-1",
      data: [100, 200, 310, 100, 1500, 1871, 2000, 1200, 1000, 900, 101, 100],
    },
  ]);

  return (
    <Col xl={12}>
      <Card className="card-height-100">
        <div className="card-header align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Loan Amount</h4>
          <div className="flex-shrink-0">
            <Link to="#!" className="btn btn-soft-danger btn-sm ms-1">
              All
            </Link>
            <Link to="#!" className="btn btn-soft-danger btn-sm ms-1">
              1M
            </Link>
            <Link to="#!" className="btn btn-soft-danger btn-sm ms-1">
              6M
            </Link>
            <Link to="#!" className="btn btn-soft-primary btn-sm ms-1">
              1Y
            </Link>
          </div>
        </div>
        <CardBody>
          <div style={{ width: "100%" }}>
            <Chart options={isBarChart} series={isBarChartSeries} type="line" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LoanChart;
